<mat-accordion displayMode="flat">

    <mat-expansion-panel></mat-expansion-panel>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Products</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="products">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="products/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="products/merge">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Deprecate</div>
                </a>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Orders</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="orders">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Customers</div>
            </mat-list-item>
        </mat-expansion-panel-header> 
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="customers">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Lookup</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="customers/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
            <ng-container>
                <a mat-list-item routerLink="customers/merge">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Merge</div>
                </a>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Administrators</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="administrators">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Browse</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="administrators/add">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Add</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Abuse</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="thresholds">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Thresholds</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="alerts">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Alerts</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item routerLink="hijacks">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Hijacks</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    <mat-divider></mat-divider>

    <mat-expansion-panel hideToggle class="mat-elevation-z0">
        <mat-expansion-panel-header collapsedHeight="64px" expandedHeight="64px">
            <mat-list-item class="fg-primary-contrast">
                <div class="compressed buc" matListItemTitle>Reports</div>
            </mat-list-item>
        </mat-expansion-panel-header>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('customers')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Customers</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('products')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Products</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('orders')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Orders</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('orders_products')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Products per order</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('downloads')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Downloads</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('alerts')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Alerts</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('hijacks')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Hijacks</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
        <mat-nav-list>
            <ng-container>
                <a mat-list-item (click)="rpt.download('endpoints')">
                    <mat-icon matListItemIcon>chevron_right</mat-icon>
                    <div class="compressed">Endpoints</div>
                </a>
                <mat-divider></mat-divider>
            </ng-container>
        </mat-nav-list>
    </mat-expansion-panel>
    
    <mat-expansion-panel hideToggle></mat-expansion-panel>


  </mat-accordion>